import React from 'react';
import '../styles/Break.css'
import { useTranslation } from 'react-i18next';

export default function Break() {
  const {t} = useTranslation();
  return (
    <section className='Break-container'>
        <div className='Break-content'>
            <h1>{t('Restez')}</h1>
        </div>
    </section>
  )
}
